import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mic, Send } from 'lucide-react';
import { Header } from './Header';
import { EmotionTag } from './EmotionTag';
interface MoodInputScreenProps {
  onSubmit: (mood: string) => void;
  onSettingsClick: () => void;
}
const emotions = [{
  emoji: '😰',
  label: 'Anxious'
}, {
  emoji: '🙏',
  label: 'Grateful'
}, {
  emoji: '😢',
  label: 'Sad'
}, {
  emoji: '😊',
  label: 'Joyful'
}, {
  emoji: '🤔',
  label: 'Confused'
}, {
  emoji: '😌',
  label: 'Peaceful'
}, {
  emoji: '😠',
  label: 'Angry'
}, {
  emoji: '✨',
  label: 'Hopeful'
}];
export function MoodInputScreen({
  onSubmit,
  onSettingsClick
}: MoodInputScreenProps) {
  const [mood, setMood] = useState('');
  const [selectedEmotion, setSelectedEmotion] = useState<string | null>(null);
  const handleEmotionClick = (label: string) => {
    setSelectedEmotion(label);
    setMood(label);
  };
  const handleSubmit = () => {
    if (mood.trim()) {
      onSubmit(mood);
    }
  };
  return <div className="min-h-screen bg-gradient-to-b from-sky-50 to-white flex flex-col" data-id="element-118">
      <Header onSettingsClick={onSettingsClick} data-id="element-119" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="flex-1 flex flex-col items-center justify-center px-6 py-8" data-id="element-120">
        <div className="w-full max-w-md" data-id="element-121">
          {/* Heading */}
          <h2 className="text-3xl font-bold text-slate-800 text-center mb-2" data-id="element-122">
            How do you feel today?
          </h2>
          <p className="text-slate-600 text-center mb-8" data-id="element-123">
            Share what's on your heart, and we'll find the perfect Scripture for
            you
          </p>

          {/* Text Input */}
          <div className="relative mb-6" data-id="element-124">
            <textarea value={mood} onChange={e => {
            setMood(e.target.value);
            setSelectedEmotion(null);
          }} placeholder="I'm feeling..." className="w-full px-6 py-4 pr-14 bg-white border-2 border-slate-200 rounded-2xl focus:border-sky-400 focus:outline-none focus:ring-2 focus:ring-sky-400/20 resize-none text-slate-800 placeholder:text-slate-400 min-h-[120px]" aria-label="Describe your mood" data-id="element-125" />
            <button onClick={() => {}} className="absolute right-4 bottom-4 p-2.5 bg-sky-100 text-sky-600 rounded-full hover:bg-sky-200 transition-colors focus:outline-none focus:ring-2 focus:ring-sky-400" aria-label="Voice input" data-id="element-126">
              <Mic className="w-5 h-5" data-id="element-127" />
            </button>
          </div>

          {/* Emotion Tags */}
          <div className="mb-8" data-id="element-128">
            <p className="text-sm text-slate-600 mb-3" data-id="element-129">Or choose a feeling:</p>
            <div className="flex flex-wrap gap-2" data-id="element-130">
              {emotions.map(emotion => <EmotionTag key={emotion.label} emoji={emotion.emoji} label={emotion.label} selected={selectedEmotion === emotion.label} onClick={() => handleEmotionClick(emotion.label)} data-id="element-131" />)}
            </div>
          </div>

          {/* Submit Button */}
          <button onClick={handleSubmit} disabled={!mood.trim()} className="w-full flex items-center justify-center gap-2 px-6 py-4 bg-gradient-to-r from-sky-400 to-purple-400 text-white font-semibold rounded-xl hover:shadow-lg transition-all focus:outline-none focus:ring-2 focus:ring-purple-400 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-132">
            <span data-id="element-133">Find Encouragement</span>
            <Send className="w-5 h-5" data-id="element-134" />
          </button>
        </div>
      </motion.div>
    </div>;
}